import { useFetchOrgSettings } from '@/http/queries/useFetchOrgSettings';
import { isGovernanceVisible } from '@/guards/governanceVisibility';

export function useGovernanceVisibility() {
  const { data: settings, isLoading } = useFetchOrgSettings();

  return {
    isLoading,
    isVisible: isGovernanceVisible(settings),
  };
}
